import Repository from "../../repository";

export default {
    GetWaitingForApproval: (payload) => Repository.post(`/api/ShippingIncurreds/GetWaitingForApproval`, payload),
    Approval: (payload) => Repository.post(`/api/ShippingIncurreds/Approval`, payload),
    AddFee: (payload) => Repository.post(`/api/ShippingIncurreds/AddFee`, payload),
    AddRevenue: (payload) => Repository.post(`/api/ShippingIncurreds/AddRevenue`, payload),
}